
export default {
    logs: {},
    monthReportLogs: [],
    monthReportParams: null,
}
